import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { Image, Text, View } from 'react-native';
import { formatDateDot } from '../utils/date';
export default function QuestItem({ source, title, completedAt, }) {
    return (_jsxs(View, { className: "items-center gap-[6px]", children: [_jsx(View, { className: "h-[84px] w-[84px] overflow-hidden rounded-[42px]", style: (completedAt === null || completedAt === void 0 ? void 0 : completedAt.value)
                    ? {
                        boxShadow: [
                            {
                                offsetX: 0,
                                offsetY: 0,
                                blurRadius: 5,
                                spreadDistance: 0,
                                color: 'rgba(0, 0, 0, 0.05)',
                            },
                        ],
                    }
                    : undefined, children: _jsx(Image, { source: source, className: "h-[84px] w-[84px]" }) }), _jsxs(View, { className: "items-center gap-[2px]", children: [_jsx(Text, { className: "font-pretendard-medium text-[14px] leading-[20px] text-black", children: title }), _jsx(Text, { className: "font-pretendard-regular text-[12px] leading-[16px] text-gray-50", children: (completedAt === null || completedAt === void 0 ? void 0 : completedAt.value)
                            ? `${formatDateDot(completedAt === null || completedAt === void 0 ? void 0 : completedAt.value)} 획득`
                            : '' })] })] }));
}
function QuestItemGap() {
    return _jsx(View, { className: "h-4" });
}
QuestItem.Gap = QuestItemGap;
